import React, { } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon
    ,MDBModal,MDBModalBody , MDBModalHeader } from 'mdbreact';


    



const WarningBox=(props)=> {


    return (
        <MDBContainer>
            <MDBModal
              
                backdrop={false}
                isOpen={props.isOpen}
                toggle={props.toggleModal}
            >
                <MDBModalHeader
                className="text-left black-text cloudy-knoxville-gradient"
                titleClass="w-100"
                tag="h5"
              
                >
                
                   
                      
                </MDBModalHeader>
                <MDBModalBody className="text-center">
                    <MDBRow>
                        <MDBCol
                        size="3"
                        className="text-center"
                        >
                         <MDBIcon icon="exclamation-triangle" size="5x" className="orange-text" />  
                       
                        </MDBCol>
                        <MDBCol size="9" className="black-text text-center">
                        <p> 
                        
                        </p>
                        <p>
                           
                            {props.errorMessage}
                          
                        </p>
                        <p className="text-center">
                                <MDBBtn className="cloudy-knoxville-gradient black-text" onClick={props.toggleModal}>
                                Got it
                            </MDBBtn>
                        </p>
                        </MDBCol>
                  </MDBRow>
                  
                </MDBModalBody>
            </MDBModal>
            
              {/* <MDBModal
                size="lg"
                className="modal-notify modal-grey text-white"
              
                backdrop={false}
                isOpen={props.isOpen}
                toggle={props.toggleModal}
              >
                <MDBModalHeader tag="p" toggle={props.toggleModal}>
                  <strong>WARNING</strong>
                </MDBModalHeader>
                <MDBModalBody>
                  <MDBRow>
                    <MDBCol
                      size="3"
                      className="d-flex justify-content-center align-items-center"
                    >
                      <MDBIcon size="4x" icon="exclamation-triangle" className="ml-1" />
                    </MDBCol>
                    <MDBCol size="9">
                      <p> 
                    
                      </p>
                      <p>
                        <strong>
                        {props.errorMessage}
                        </strong>
                      </p>
                  
                    </MDBCol>
                  </MDBRow>
                </MDBModalBody>
                <MDBModalFooter className="justify-content-center">
                  <MDBBtn color="danger" onClick={props.toggleModal}>
                    Got it. 
                    <MDBIcon icon="diamond" className="ml-1 white-text" />
                  </MDBBtn>
                  
                </MDBModalFooter>
              </MDBModal> */}
          
        </MDBContainer>
    )
}

export default WarningBox
